import { render, staticRenderFns } from "./AccountOrderDetails.vue?vue&type=template&id=f9472e8a&"
import script from "./AccountOrderDetails.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccountOrderDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports